import { render, staticRenderFns } from "./MasterAdd.vue?vue&type=template&id=2599583f&scoped=true"
import script from "./MasterAdd.vue?vue&type=script&lang=js"
export * from "./MasterAdd.vue?vue&type=script&lang=js"
import style0 from "./MasterAdd.vue?vue&type=style&index=0&id=2599583f&prod&lang=css"
import style1 from "./MasterAdd.vue?vue&type=style&index=1&id=2599583f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2599583f",
  null
  
)

export default component.exports